export enum SubmitForReviewFieldKeys {
  Reviewer = 'reviewer',
  Message = 'message',
}

export enum RejectReviewFieldKeys {
  Message = 'message',
}
